import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { PersonaProvider } from "@/context/PersonaContext";
import { SessionProvider } from "@/context/SessionContext";
import { Nav } from "@/components/Nav";
import { Footer } from "@/components/Footer";
import { Toaster } from "@/components/ui/sonner";
import Doorway from "@/pages/Doorway";
import SimpleDemo from "@/pages/SimpleDemo";
import Explore from "@/pages/Explore";
import StaffWorkspace from "@/pages/StaffWorkspace";
import InviteEntry from "@/pages/InviteEntry";
import Workspace from "@/pages/Workspace";
import CoreLanding from "@/pages/CoreLanding";
import ReferenceHub from "@/pages/ReferenceHub";
import CanvasHome from "@/pages/CanvasHome";
import InductionJourney from "@/pages/InductionJourney";
import RoomHireJourney from "@/pages/RoomHireJourney";
import ActivityReturnJourney from "@/pages/ActivityReturnJourney";
import CommunityGuideJourney from "@/pages/CommunityGuideJourney";
import OnboardingJourney from "@/pages/OnboardingJourney";
import InvitePage from "@/pages/InvitePage";
import ReceiptPublic from "@/pages/ReceiptPublic";

function App() {
  return (
    <div className="min-h-screen bg-mill-bg font-sans text-mill-ink">
      <BrowserRouter>
        <SessionProvider>
          <PersonaProvider>
            <Nav />
            <main>
              <Routes>
                {/* Simple demonstrator — primary experience */}
                <Route path="/" element={<SimpleDemo />} />
                <Route path="/hub" element={<Doorway />} />
                <Route path="/explore" element={<Explore />} />
                <Route path="/staff" element={<StaffWorkspace />} />
                <Route path="/invite/:token" element={<InviteEntry />} />
                <Route path="/me" element={<Workspace />} />

                {/* Secondary internal — showcase, design notes, future model */}
                <Route path="/overview" element={<CoreLanding />} />

                {/* Parked reference — retained, not deleted */}
                <Route path="/reference" element={<ReferenceHub />} />
                <Route path="/reference/overview" element={<CanvasHome />} />
                <Route path="/reference/invite/:token" element={<InvitePage />} />
                <Route path="/journey/induction" element={<InductionJourney />} />
                <Route path="/journey/room-hire" element={<RoomHireJourney />} />
                <Route path="/journey/activity-return" element={<ActivityReturnJourney />} />
                <Route path="/journey/community-guide" element={<CommunityGuideJourney />} />
                <Route path="/journey/onboarding" element={<OnboardingJourney />} />
                <Route path="/r/:hash" element={<ReceiptPublic />} />

                {/* Retired core routes -> new IA */}
                <Route path="/core/admin" element={<Navigate to="/staff" replace />} />
                <Route path="/core/booking" element={<Navigate to="/staff" replace />} />
                <Route path="/core/invite/:token" element={<RedirectInvite />} />
              </Routes>
            </main>
            <Footer />
            <Toaster position="top-right" richColors />
          </PersonaProvider>
        </SessionProvider>
      </BrowserRouter>
    </div>
  );
}

function RedirectInvite() {
  const token = window.location.pathname.split("/").pop();
  return <Navigate to={`/invite/${token}`} replace />;
}

export default App;
